<template>
  <div>
    <Form :model="basicModel" class="inputForm basicSelectInput" ref="basicForm" :rules="basicRules"> 
            <h3>
                {{$t('verifyTitle1')}}
            </h3>
            <FormItem prop="title" class="item4" >
                <effect-select :label='$t("basicTitle")' v-model="basicModel.title" :options='titleOptions' :isLanguage='true'></effect-select>
            </FormItem>
            <FormItem  prop="firstName" class="item4">
                <effect-input :label='$t("basicFirst")'  v-model="basicModel.firstName"></effect-input>
            </FormItem>
            <FormItem  prop="middleName" class="item4">
                <effect-input :label='$t("basicMiddle")'  v-model="basicModel.middleName"></effect-input>
            </FormItem>
            <FormItem  prop="lastName" class="item4 last">
                <effect-input :label='$t("basicLast")'  v-model="basicModel.lastName"></effect-input>
            </FormItem>
            <FormItem  prop="day" class="item3">
                <effect-select :label='$t("basicDay")'  v-model="basicModel.day" :options='dayOptions' :isLanguage='false'></effect-select>
            </FormItem>
            <FormItem  prop="month" class="item3">
                <effect-select :label='$t("basicMonth")'  v-model="basicModel.month" :options='monthOptions' :isLanguage='true'></effect-select>
            </FormItem>
            <FormItem  prop="year" class="item3 last">
                <effect-select :label='$t("basicYear")' v-model="basicModel.year" :options='yearOptions' :isLanguage='false'></effect-select>
            </FormItem>
            <h3>
                {{$t('verifyTitle2')}}
            </h3>
            <FormItem  prop="suiteNumber" class="item3">
                <effect-input :label='$t("basicHouse")'  v-model="basicModel.suiteNumber"></effect-input>
            </FormItem>
            <FormItem prop="streetAddress" class="item3" >
                <effect-input :label='$t("basicStreet")'  v-model="basicModel.streetAddress"></effect-input>
            </FormItem>
            <FormItem  prop="city" class="item3 last">
                <effect-input :label='$t("basicCity")'  v-model="basicModel.city"></effect-input>
            </FormItem>
            <FormItem  prop="province" class="item3">
                <effect-input :label='$t("basicProvince")'  v-model="basicModel.province"></effect-input>
            </FormItem>
            <FormItem  prop="postcode" class="item3">
                <effect-input :label='$t("basicCode")'  v-model="basicModel.postcode"></effect-input>
            </FormItem>
            <FormItem  prop="country" class="item3 last">
                <effect-select :label='$t("basicCountry")'  v-model="basicModel.country" :options='countryList' :isLanguage='false' :filterable="filterable"></effect-select>
            </FormItem>
            <FormItem  prop="countryCode" class="item3">
                <effect-select :label='$t("basicPhonearea")'  v-model="basicModel.countryCode" :options='phoneList' :isLanguage='false' :filterable="filterable"></effect-select>
            </FormItem>
            <FormItem  prop="phoneNumber" class="item3">
                <effect-input :label='$t("basicPhonearea")'  v-model="basicModel.phoneNumber"></effect-input>
            </FormItem>
            <FormItem  prop="liveTime" class="item3 last">
                <effect-select :label='$t("basicQuestion1")' v-model="basicModel.liveTime" :options='liveOptions' :isLanguage='true'></effect-select>
            </FormItem>
            <FormItem class="itemBtns" v-if="basicModel.liveTime == 1" >
                <p>
                    {{$t('beforeAddress')}}
                </p>
            </FormItem>
            <FormItem  prop="suiteNumber2" class="item3" v-if="basicModel.liveTime == 1">
                <effect-input :label='$t("basicHouse")'  v-model="basicModel.suiteNumber2"></effect-input>
            </FormItem>
            <FormItem prop="streetAddress2" class="item3"  v-if="basicModel.liveTime == 1">
                <effect-input :label='$t("basicStreet")'  v-model="basicModel.streetAddress2"></effect-input>
            </FormItem>
            <FormItem  prop="city2" class="item3 last" v-if="basicModel.liveTime == 1">
                <effect-input :label='$t("basicCity")' v-model="basicModel.city2"></effect-input>
            </FormItem>
            <FormItem  prop="province2" class="item3" v-if="basicModel.liveTime == 1">
                <effect-input :label='$t("basicProvince")' v-model="basicModel.province2"></effect-input>
            </FormItem>
            <FormItem  prop="postcode2" class="item3" v-if="basicModel.liveTime == 1">
                <effect-input :label='$t("basicCode")'  v-model="basicModel.postcode2"></effect-input>
            </FormItem>
            <FormItem  prop="country2" class="item3 last" v-if="basicModel.liveTime == 1">
                <effect-select :label='$t("basicCountry")' v-model="basicModel.country2" :options='countryList' :isLanguage='false' :filterable="filterable"></effect-select>
            </FormItem>
            <FormItem  prop="countryCode2" class="item3 " v-if="basicModel.liveTime == 1">
                <effect-select :label='$t("basicPhonearea")'  v-model="basicModel.countryCode2" :options='phoneList' :isLanguage='false' :filterable="filterable"></effect-select>
            </FormItem>
            <FormItem  prop="phoneNumber2" class="item3" v-if="basicModel.liveTime == 1">
                <effect-input :label='$t("basicPhonearea")'  v-model="basicModel.phoneNumber2"></effect-input>
            </FormItem>
            <FormItem  prop="isCitizen" class="item3" :class="basicModel.isCitizen == '1'?'':'last'">
                <effect-select :label='$t("basicQuestion2")'  v-model="basicModel.isCitizen" :options='isAemerica' :isLanguage='true'></effect-select>
            </FormItem>
            <FormItem  prop="tin" class="item3" v-if="basicModel.isCitizen == 1">
                <effect-input :label='$t("ustax")'  v-model="basicModel.tin"></effect-input>
            </FormItem>
            <FormItem class="itemBtns">
                <Button type="primary" class="formBtn"  @click="next">{{$t('next')}}</Button>
            </FormItem>
    </Form>
    <loading :isSpinShow="loading"></loading>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import EffectInput from '@/components/EffectInput.vue';
import EffectSelect from '@/components/EffectSelect.vue';
import Loading from '@/components/Loading.vue';




export default {
  name: 'Home',
  components: {
    EffectInput, 
    EffectSelect,
    Loading
  },
  data(){
    return{
        basicModel:{
            title: "",
            firstName: "",
            middleName: "",
            lastName: "",
            day: 0,
            month: 0,
            year: 0,
            streetAddress: "",
            suiteNumber: "",
            city: "",
            province: "",
            postcode: "",
            country: "",
            countryCode: "",
            phoneNumber: "",
            liveTime: "",
            streetAddress2: "",
            suiteNumber2: "",
            city2: "",
            province2: "",
            postcode2: "",
            country2: "",
            countryCode2: "",
            phoneNumber2: "",
            tin: "",
            isCitizen: ""
        },
        basicRules: {
            title: [
                { required: true, message:this.$t('fieldError') , trigger: 'change' },
            ],
            firstName: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            // middleName: [
            //     { required: true, message: this.$t('loginTips2') , trigger: 'blur' },
            // ],
            lastName: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            day: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            month: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            year: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            streetAddress: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            suiteNumber: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            city: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            province: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            postcode: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            country: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            countryCode: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            phoneNumber: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            liveTime: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            isCitizen: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            streetAddress2: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            suiteNumber2: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            city2: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            province2: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            postcode2: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            country2: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            countryCode2: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            phoneNumber2: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            tin: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            
        },
        titleOptions:[
            {
                value:'1',
                label:'mr'
            },
            {
                value:'2',
                label:'ms'
            },
            {
                value:'3',
                label:'miss'
            },
            {
                value:'4',
                label:'mrs'
            },
            {
                value:'5',
                label:'dr'
            },
            {
                value:'6',
                label:'Other'
            },
        ],
        monthOptions:[
            {
                value:'1',
                label:'January'
            },
            {
                value:'2',
                label:'February'
            },
            {
                value:'3',
                label:'March'
            },
            {
                value:'4',
                label:'April'
            },
            {
                value:'5',
                label:'May'
            },
            {
                value:'6',
                label:'June'
            },
            {
                value:'7',
                label:'July'
            },
            {
                value:'8',
                label:'August'
            },
            {
                value:'9',
                label:'September'
            },
            {
                value:'10',
                label:'October'
            },
            {
                value:'11',
                label:'November'
            },
            {
                value:'12',
                label:'December'
            }
        ],
        yearOptions:[],
        liveOptions:[
            {
                value:'1',
                label:'liveTime1'
            },
            {
                value:'2',
                label:'liveTime2'
            }
        ],
        isAemerica:[
            {
                value:'1',
                label:'yes'
            },
            {
                value:'2',
                label:'no'
            },
        ],
        countryList:[],
        phoneList:[],
        loading:false,
        filterable:true,

    }
    
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    created(){
        this.getDayOptions()
        this.getYearOptions()
        this.getCountry()
        this.getData()
        // console.log(this.userInfo)
    },
    methods:{
        getDayOptions(){
            this.dayOptions = []
            for (var i=1;i<32;i++) {
                var obj = {
                    value:i.toString(),
                    label:i
                }
                this.dayOptions.push(obj)
            }
            // console.log(this.dayOptions)
        },
        getYearOptions(){
            this.yearOptions = []
            // console.log(new Date().getYear())
            var myDate = new Date();
            var startYear = myDate.getFullYear() - 76;//起始年份
            var endYear = myDate.getFullYear() - 18;//结束年份
            for (var i = startYear; i <= endYear; i++) //循环年份，动态生成option列表，拼接html
            {
                // console.log(i)
                var obj = {
                    value:i.toString(),
                    label:i
                }
                this.yearOptions.push(obj)
            }
        },
        getCountry(){
            this.countryList = []
            this.phoneList = []
            this.$axios.get('/api/CreateRealAccount/Index')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    res.data.obj.forEach(e => {
                        let data = {
                            value:e.id.toString()
                        }
                        let phone = {
                            value:e.id.toString()
                        }
                        if(this.lang == 'zh'){
                            data.label = e.nameCN
                            phone.label = '+'+e.areaCode.substring(2)+' '+e.nameCN
                        }else{
                            data.label = e.name
                            phone.label = '+'+e.areaCode.substring(2)+' '+e.name
                        }
                        this.countryList.push(data)
                        this.phoneList.push(phone)
                    });
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => {
                this.$Message.error(err.data.msg)
            })
        },
        getData(){
            this.$axios.get('/api/UserQuestion/Index')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    this.basicModel = Object.assign(this.basicModel,res.data.obj.model)
                    this.basicModel.day = this.basicModel.day? this.basicModel.day.toString() : ''
                    this.basicModel.year = this.basicModel.year? this.basicModel.year.toString() : ''
                    // console.log(this.$refs.basicForm)
                    this.$refs.basicForm.fields.forEach((v,j) => {
                        // console.log(v,j)
                        v.validateDisabled = true
                        v.validateMessage = ''
                        v.validateState = ''
                    })
                    // console.log(this.basicModel)
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => this.$Message.error(err.data.msg))
        },
        next(){
            this.$refs.basicForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.$axios.post('/api/UserQuestion/BasicInformation', this.basicModel)
                    .then(async (res) => {
                        console.log(res)
                        if(res.data.status == 1){
                            this.$Message.success(this.$t('saveSucccess'))
                            this.$emit('saveSteps',1)
                            this.$emit('changeSteps',1)
                            // this.$Message.success(this.$t('loginsuccess'))
                            // this.$store.commit('setToken', res.data.obj.token)
                            // this.$store.commit('setUserInfo', res.data.obj.userInfo)
                            // this.$router.push({ path:'/myAccount'})
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => this.$Message.error(err.data.msg))
                    .finally(() => this.loading = false)
                } else {
                    // this.$Message.error('Fail!');
                }
            })
        }
    }
}
</script>
<style lang="less">
.verify{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    .content_wrapper{
        background-color: #f9fafb;
        border: 1px solid #f0f0f0;
        padding-top: 100px;
        .activate-process{
            position: relative;
            width: 60%;
            height: 3px;
            margin: 0px auto 110px;
            text-align: center;
            background-color: #e5e5e5;
            .process-item{
                position: absolute;
                top: -18px;
                left: 0px;
                transform: translateX(-50%);
                color: #332c2b;
                white-space: nowrap;
                span{
                    display: inline-block;
                    width: 34px;
                    height: 34px;
                    margin-bottom: 22px;
                    line-height: 34px;
                    color: #332c2b;
                    font-size: 14px;
                    background-color: #f5f5f5;
                    border: 1px solid #e5e5e5;
                    border-radius: 50%;
                    font-family: 'Montserrat-Regular';
                    cursor: pointer;
                }
                b{
                    font-weight: normal;
                }
            }
            .left25{
                left: 25%;
            }
            .left50{
                left: 50%;
            }
            .left75{
                left: 75%;
            }
            .left100{
                left: 100%;
            }
            .active,
            .complete,
            .finished{
                top: -24px;
                span{
                    width: 48px;
                    height: 48px;
                    margin-bottom: 14px;
                    font-size: 18px;
                    line-height: 48px;
                    background-color: #e32b3a;
                    border-color: #e32b3a;
                    color: #fff;
                    
                }
            }
            .active::after{
                content: "";
                position: absolute;
                z-index: -1;
                top: 24px;
                left: 50%;
                width: 72px;
                height: 3px;
                margin-left: 14px;
                background-color: #e32b3a;
            }
            .finished::after{
                content: "";
                position: absolute;
                z-index: -1;
                top: 24px;
                left: 70%;
                width: 160px;
                height: 4px;
                margin-left: 14px;
                background-color: #e32b3a;
            }
            
        }
    }
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
    .ivu-form-item{
        width: 48%;
    }
    
    .inputForm{
        h3{
            display: block;
            width: 100%;
            position: relative;
            margin-bottom: 20px;
            padding-left: 20px;
            font-size: 18px;
            color: #332c2b;
            font-weight: normal;
        }
        h3::before{
            content: "";
            position: absolute;
            left: 0px;
            top: 50%;
            width: 8px;
            height: 8px;
            background-color: #e32b3a;
            border-radius: 4px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
        }
        .item4{
            width: 24%;
        }
        .item3{
            width: 32%;
        }
    }
}
</style>
